import React, { useCallback } from "react";
import { useAuth0 } from "../../../react-auth0-spa";
import { Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import config from "../../../api_config.json";
import { useAppContext } from "../../../context";
import { fetchClienti } from "../../../graphql/controllers/fetchClienti";
import { updateCliente } from "../../../graphql/controllers/updateCliente";


const DissociateFornitoreButton = (props) => {
  const { value, triggerRefresh, orgId } = props;
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";

  const graphqlUrl = `${config.baseUrl[env]}/graphql`;

  const dissociateFornitore = useCallback(
    async (fornitore) => {
      try {
        const token = await getTokenSilently();
        const graphql = {
          url: graphqlUrl,
          token,
        }

        const variablesGetClienti = {
          where: {
            terzista_org_pointer: {
              have: {
                objectId: {
                  equalTo: orgId,
                }
              }
            },
            org_pointer: {
              have: {
                objectId: {
                  equalTo: fornitore.centro_servizi_pointer.objectId,
                }
              }
            },
          },
        };

        const clienti = await fetchClienti(graphql, variablesGetClienti)

        const cliente = clienti.data.length > 0 ? clienti.data[0] : {};

        const variablesUpdateClienti = {
          id: cliente.objectId,
          fields: {
            terzista_org_pointer: null,
          },
        };

        const response = await updateCliente(graphql, variablesUpdateClienti);

        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    [getTokenSilently, graphqlUrl, orgId]
  );

  return (
    <Popconfirm
      title="Dissocia il fornitore"
      description="Sei sicuro di voler dissociare questo fornitore?"
      onConfirm={async () => {
        await dissociateFornitore(value);
        await triggerRefresh();
      }}
      okText="Si"
      cancelText="No"
    >
      <Button danger
        icon={<DeleteOutlined />}
        style={{ width: 60 }}
      ></Button>
    </Popconfirm>
  );
};

export default DissociateFornitoreButton;
